import { handleActions } from "redux-actions";
import * as requestsActions from "../actions/offers";

let offersState = {
  allOffers: null,
  allOffersStat: null,
  allDrivers: null,
  filterOffers: null,
  filterOffersStat: null,
  offerById: null,
  currentRequest: false,
  successMessage: "",
  errorMessage: "",
  error: {},
  offersLoading: false,
  data: {},
  loading: false,
  updated: 0
};

export const offers = handleActions(
  {
    //    Get All Offers
    [requestsActions.getAllOffers]: (state, action) => {
      return { ...state, offersLoading: true };
    },
    [requestsActions.getOffersSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        offerTypes: payload.offerTypes,
        allOffers: payload.offers,
        allOffersStat: payload.offersStat,
        allDrivers: payload.drivers,
        pagination: payload.pagination,
        offersLoading: false
      };
    },
    [requestsActions.getOffersError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        offersLoading: false
      };
    },
    //Get Filter Offers
    [requestsActions.getFilterOffers]: state => {
      return { ...state, offersLoading: true };
    },
    [requestsActions.getFilterOffersSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        filterOffers: payload.offers,
        filterOffersStat: payload.offersStat,
        offersLoading: false
      };
    },
    [requestsActions.getFilterOffersError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        offersLoading: false
      };
    },

    [requestsActions.getOffer]: (state, action) => {
      return {
        ...state,
        offerId: action.payload.addToUrl,
        offersLoading: true
      };
    },
    [requestsActions.getOfferSuccess]: (state, action) => {
      return { ...state, offerById: action.payload, offersLoading: false };
    },
    [requestsActions.createOffer]: (state, action) => {
      return { ...state, loading: true };
    },
    [requestsActions.createOfferSuccess]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        updated: state.updated ? state.updated + 1 : 1
      };
    },
    [requestsActions.createOfferFailure]: (state, action) => {
      return {
        ...state,
        loading: false,
        errorMessage: action.payload && action.payload.message,
        error: {
          message:
            action.payload &&
            action.payload.data &&
            action.payload.data.message,
          data:
            action.payload && action.payload.data && action.payload.data.errors,
          status:
            action.payload && action.payload.data && action.payload.data.code
        }
      };
    },
    // //Get Search Requests
    // [requestsActions.searchOffers]: state => {
    //   return { ...state, loading: true };
    // },
    // [requestsActions.searchOffersSuccess]: (state, action) => {
    //   let { payload } = action;
    //   return {
    //     ...state,
    //     allOffers: payload.data,
    //     loading: false,
    //   };
    // },
    // [requestsActions.searchOffersError]: (state, action) => {
    //   let { payload } = action;
    //   return {
    //     ...state,
    //     errorMessage: payload.data.message,
    //     requestsLoading: false,
    //   };
    // },
    // Get a Request for which we are creating an offer
    [requestsActions.currentRequest]: (state, action) => {
      return {
        ...state,
        loading: true
      };
    },
    [requestsActions.currentRequestSuccess]: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        currentRequest: payload.data
      };
    },
    [requestsActions.currentRequestFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload.message,
        loading: false
      };
    },
    //  Update Offer
    [requestsActions.updateOffer]: state => {
      return { ...state, loading: true };
    },
    [requestsActions.updateOfferSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        offerById: payload,
        loading: false,
        updated: state.updated ? state.updated + 1 : 1
      };
    },
    [requestsActions.updateOfferError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        loading: false
      };
    }
  },
  offersState
);
